import { FormBase } from 'core/components';
import moment from 'moment';
import validatorjs from 'validatorjs';

export default class ShipmentCostForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			validateOnChange: false,
			validateOnChangeAfterSubmit: true,
		});
	}
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'dateFormat',
			value => {
				return moment(value, 'L', true).isValid();
			},
			'INVALIDDATEFORMAT'
		);
		return {
			fields: [
				{
					name: 'dateRangeStart',
					label: 'SHIPMENTCOST.DATERANGESTART',
					rules: 'required|dateFormat',
				},
				{
					name: 'dateRangeEnd',
					label: 'SHIPMENTCOST.DATERANGEEND',
					rules: 'dateFormat',
				},
				{
					name: 'searchTrackingNumber',
					placeholder: 'SEARCHTRACKINGNUMBER',
					value: '',
				},
				{
					name: 'showOnlyDiscrepancies',
					label: 'SHIPMENTCOST.SHOWONLYMISSBILLED',
					type: 'checkbox',
					value: false,
				},
				{
					name: 'showOnlyOvercharged',
					label: 'SHIPMENTCOST.OVERCHARGED',
					value: false,
				},
				{
					name: 'showOnlyUndercharged',
					label: 'SHIPMENTCOST.UNDERCHARGED',
					value: false,
				},
				{
					name: 'showOnlyWithBilling',
					label: 'SHIPMENTCOST.SHOWONLYWITHBILLING',
					type: 'checkbox',
					value: true,
				},
			],
		};
	}
}
